import { apiKeycloak, api } from '@/libs/axios/axios'
import { getMetricsQuery } from './graphql'

export const useUsersApi = () => {
  // change api base url default
  const getUserKcProfile = async () => {
    const { data } = await apiKeycloak.get(
      `/realms/${import.meta.env.VITE_KEYCLOAK_REALM}/account/`,
    )
    return data
  }

  const updateUserKcProfile = async (kcProfile) => {
    await apiKeycloak.post(
      `/realms/${import.meta.env.VITE_KEYCLOAK_REALM}/account/`,
      kcProfile,
    )
  }

  const getUserMetrics = async () => {
    const { data } = await api.post('/graphql', {
      query: getMetricsQuery,
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.getMetrics
  }

  return {
    getUserKcProfile,
    updateUserKcProfile,
    getUserMetrics,
  }
}
